<template>
    <div class="settlement-invoicing">
        <div class="content-box first">
            <div class="steps">
                <div class="step-item">
                    <div class="num">STEP1</div>
                    <div class="title">盖章版税结算单</div>
                    <p>前往版权收益页面，选择还未提现的版税，进入详情，下载结算单盖章：将结算单打印后，盖公司章</p>
                    <a href="/manage/settlement/versionTax" class="color-base underline">版权收益页面</a>
                    <div class="ft">01</div>
                </div>
                <div class="step-item">
                    <div class="num">STEP2</div>
                    <div class="title">开发票</div>
                    <p>按照结算单金额，开具发票；</p>
                    <a href="#" class="color-base underline" @click.prevent="invoiceVisible = true">发票内容指引</a>
                    <div class="ft">02</div>
                </div>
                <div class="step-item">
                    <div class="num">STEP3</div>
                    <div class="title">邮寄发票和结算单</div>
                    <p>将盖章的结算单和发票，邮寄至以下指定地址其中发票邮寄第二、三联</p>
                    <a href="#" class="color-base underline" @click.prevent="addressVisible = true">查看邮寄地址</a>
                    <div class="ft">03</div>
                </div>
                <div class="step-item">
                    <div class="num">STEP4</div>
                    <div class="title">等待收款到账</div>
                    <p>如果您的发票和结算单都没有问题，10个工作日内，您设置的银行账号将会收到资金</p>
                    <div class="ft">04</div>
                </div>
            </div>
        </div>
        <el-dialog title="发票内容指引" :visible.sync="invoiceVisible" append-to-body width="600px">
            <div class="sr-descriptions" style="width: auto">
                <!-- <div class="item">
                    <label>企业名称</label>
                    <div class="text">成都太合乐动科技有限公司</div>
                </div>
                <div class="item">
                    <label>统一社会代码</label>
                    <div class="text">915101000928342631</div>
                </div>
                <div class="item">
                    <label>公司地址</label>
                    <div class="text">四川成都高新区吉泰五路88号2栋28层2801号</div>
                </div>
                <div class="item">
                    <label>电话号码</label>
                    <div class="text">028 65784739</div>
                </div>
                <div class="item">
                    <label>开户行</label>
                    <div class="text">中国农业银行成都新希望国际支行</div>
                </div>
                <div class="item">
                    <label>银行账号</label>
                    <div class="text">228 082 010 400 008 10</div>
                </div>
                <div class="item">
                    <label>开票内容</label>
                    <div class="text">版税部分：无形资产*版权使用费/版权费；邀请收益：xxxxxxx/xxxxx （请分开两项开票）</div>
                </div>
                <div class="item">
                    <label>开票类型</label>
                    <div class="text">增值税专用发票</div>
                </div> -->
                <div v-html="content"></div>
            </div>
        </el-dialog>
        <el-dialog title="查看邮寄地址" :visible.sync="addressVisible" append-to-body width="600px">
            <div class="sr-descriptions" style="width: auto">
                <!-- <div class="item">
                    <label>发票邮寄地址</label>
                    <div class="text">北京朝阳区八里庄街道莱锦文化创意产业园CN07太合音乐集团</div>
                </div>
                <div class="item">
                    <label>收件人</label>
                    <div class="text">刘琪</div>
                </div>
                <div class="item">
                    <label>收件人电话</label>
                    <div class="text">15084367673</div>
                </div> -->
                <div v-html="address"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            invoiceVisible: false,
            addressVisible: false,
            content: '',
            address: '',
        };
    },
    created() {
        this.fetch1();
        this.fetch2();
    },
    methods: {
        async fetch1() {
            const response = await this.$request({
                url: '/faq/cp_faq/view/getByEntryKeyOnlyFirstLvl',
                method: 'POST',
                params: {faqKey: 'companyinvoiceinstrument'},
            });
            const {state, msg, result} = response.data;
            if (!state) this.$message.error(msg || '请求失败');
            if (result.length > 0) {
                this.content = result[0].content;
            }
        },
        async fetch2() {
            const response = await this.$request({
                url: '/faq/cp_faq/view/getByEntryKeyOnlyFirstLvl',
                method: 'POST',
                params: {faqKey: 'invoicemailaddress'},
            });
            const {state, msg, result} = response.data;
            if (!state) this.$message.error(msg || '请求失败');
            if (result.length > 0) {
                this.address = result[0].content;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.settlement-invoicing {
    .steps {
        display: flex;
        width: 800px;
        margin: 80px auto;

        .step-item {
            height: 400px;
            padding: 0 40px 0 20px;
            border-left: 1px solid $--border-color-base;
            position: relative;
            flex: 1;

            a:hover {
                color: $--color-base;
                opacity: 0.8;
            }

            .num {
                width: 131px;
                height: 36px;
                background: $--color-black;
                position: absolute;
                left: 0px;
                top: 20px;
                color: $-text-50;
                font-size: 18px;
                font-weight: bold;
                line-height: 36px;
                padding-left: 16px;

                &::before {
                    width: 0;
                    height: 0;
                    border-left: 18px solid transparent;
                    border-right: 18px solid $--color-white;
                    border-top: 36px solid transparent;
                    content: '';
                    position: absolute;
                    right: 0px;
                    top: 0px;
                }
            }

            .title {
                font-size: 16px;
                color: $-text-950;
                line-height: 16px;
                margin-top: 96px;
            }

            p {
                font-size: 12px;
                color: $-text-500;
                margin-top: 6px;
                margin-bottom: 20px;
                line-height: 20px;
                min-height: 80px;
            }

            .ft {
                font-size: 60px;
                color: $--color-grey;
                line-height: 60px;
                font-weight: bold;
                position: absolute;
                right: 40px;
                bottom: 0px;
            }
        }
    }
}
</style>
